import type { InMemoryScrollingOptions, RouterConfigOptions, Routes } from '@angular/router';
import { PageNotFoundComponent } from 'vnext-widgets';

export const DEFAULT_ROUTES: Routes = [
  { path: '404', component: PageNotFoundComponent },
  { path: '**', redirectTo: '404' }
];

export const ROUTER_CONFIG_OPTIONS: RouterConfigOptions = {
  onSameUrlNavigation: 'reload'
};

export const IN_MEMORY_SCROLLING_OPTIONS: InMemoryScrollingOptions = {
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'top'
};

export const VIEWPORT_SCROLL_OFFSET: [number, number] = [0, 64];
